module.exports = __webpack_public_path__ + "img/6814e39.png";